<nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
  <a id="logo" class="col-md-2 navbar-brand" href="#">
    <button class="btn btn-outline-secondary pull-left d-block d-md-none" style="font-size: 12px;"
            (click)="visibleMobileNav = true;"><i class="fa fa-filter"></i></button>
    <img class="logo" src="assets/android-chrome-192x192.png">
    ARSelector <span class="tiny">ALPHA</span>
  </a>
  <div id="subheading" class="w-100 text-center text-light font-italic">Helping with filtering to select an appropriate
    in classroom system!
  </div>
</nav>

<div class="container-fluid">
  <div class="row">
    <nav id="mobile-filter" class="col-12 d-block d-md-none" *ngIf="visibleMobileNav">
      <div class="close-nav pull-right" (click)="visibleMobileNav = false">
        <i class="fa fa-times fa-3x"></i>
      </div>
      <div class="sidebar-sticky">
        <div class="col-12" style="margin-top: 15px;">
          <h4>
            {{filterApplied}} filter applied <i class="fa fa-refresh btn-custom" (click)="resetFilters()"
                                                style="margin-left: 5px; cursor: pointer;"></i>
          </h4>
        </div>
        <div *ngFor="let item of filters | keys;">
          <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>{{filters[item]?.name}}</span>
          </h6>
          <ul class="nav flex-column">
            <li class="nav-item" *ngFor="let subItem of filters[item]?.subItems | keys">
              <a class="nav-link">
                {{filters[item]?.subItems[subItem]?.name}}
                <div *ngIf="filters[item]?.subItems[subItem]?.subItems">
                  <button class="btn"
                          [class.btn-outline-secondary]="!filters[item]?.subItems[subItem]?.subItems[filterItem]?.selected"
                          [class.btn-primary]="filters[item]?.subItems[subItem]?.subItems[filterItem]?.selected"
                          [class.active]="filters[item]?.subItems[subItem]?.subItems[filterItem]?.selected"
                          *ngFor="let filterItem of filters[item]?.subItems[subItem]?.subItems | keys"
                          (click)="toggleFilter(filters[item]?.subItems[subItem]?.subItems[filterItem])"
                          style="margin-right: 3px; margin-bottom: 3px;">
                    {{filters[item]?.subItems[subItem]?.subItems[filterItem]?.name}} <span
                    *ngIf="filters[item]?.subItems[subItem]?.subItems[filterItem]?.remainingItems !== -1">({{filters[item]?.subItems[subItem]?.subItems[filterItem]?.remainingItems}}
                    )</span>
                  </button>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <nav id="filters" class="col-md-2 d-none d-md-block bg-light sidebar">
      <div class="sidebar-sticky">
        <div class="col-12" style="margin-top: 15px;">
          <h5>
            {{filterApplied}} filter applied <i class="fa fa-refresh btn-custom" (click)="resetFilters()"
                                                style="margin-left: 5px; cursor: pointer;"></i>
          </h5>
        </div>
        <div *ngFor="let item of filters | keys;">
          <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>{{filters[item]?.name}}</span>
          </h6>
          <ul class="nav flex-column">
            <li class="nav-item" *ngFor="let subItem of filters[item]?.subItems | keys">
              <a class="nav-link">
                {{filters[item]?.subItems[subItem]?.name}}
                <div *ngIf="filters[item]?.subItems[subItem]?.subItems">
                  <button class="btn"
                          [class.btn-outline-secondary]="!filters[item]?.subItems[subItem]?.subItems[filterItem]?.selected"
                          [class.btn-primary]="filters[item]?.subItems[subItem]?.subItems[filterItem]?.selected"
                          [class.active]="filters[item]?.subItems[subItem]?.subItems[filterItem]?.selected"
                          *ngFor="let filterItem of filters[item]?.subItems[subItem]?.subItems | keys"
                          (click)="toggleFilter(filters[item]?.subItems[subItem]?.subItems[filterItem])"
                          style="margin-right: 3px; margin-bottom: 3px;">
                    {{filters[item]?.subItems[subItem]?.subItems[filterItem]?.name}} <span
                    *ngIf="filters[item]?.subItems[subItem]?.subItems[filterItem]?.remainingItems !== -1">({{filters[item]?.subItems[subItem]?.subItems[filterItem]?.remainingItems}}
                    )</span>
                  </button>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <main id="content" role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <div class="container">
          <app-home [items]="items" [itemKeys]="itemKeys"
                    (switchPartlySupportedFeatures)="switchPartlySupportedFeatures($event)"></app-home>
          <!-- <router-outlet></router-outlet> -->
        </div>
      </div>
    </main>
  </div>
</div>
